const shapeJson = 
[
  {
    "measurements": "25cm (H) x 29cm (W) x 11.5cm (D)",
    "price": 148.00,
    "type": "backpack",
    "categories": ["backpack","handbag"],
    "shape": "Harriet",
    "name": "Harriet Backpack",
    "productInfo": "2 carry handles, Detachable and adjustable shoulder straps, 1 main compartment with zip closure, 2 inside zipped pockets, 2 inside open pockets, 2 external pockets",
    "ranges": ["shopfront"],
    "size": "large",
    "shapeId": "harriet",
    "id": "769"
  },
  {
    "measurements": "Dimensions: 11cm (H) x 17cm (W) x 4cm (D)",
    "price": 55.00,
    "type": "Purse",
    "categories": ["Wallet","Purse","Cardholder"],
    "shape": "Double Zipper Coin",
    "name": "Double Zipper Coin Purse",
    "productInfo": "2 compartments with zip closure, 3 card slots",
    "ranges": ["boutique"],
    "size": "small",
    "shapeId": "doublezippercoin",
    "id": "707"
  },
{
    "measurements": "Dimensions: 24cm (H) x 32cm (W) x 10cm (D)",
    "price": 135.00,
    "type": "Backpack",
    "categories": ["Handbag","Backpack"],
    "shape": "Classic Backpack",
    "name": "Classic Backpack",
    "productInfo": "1 main compartment with zip closure, 1 inside zipped pocket, 2 inside open pockets, Detachable and adjustable shoulder straps, Comfortable handle",
    "ranges": ["boutique"],
    "size": "large",
    "shapeId": "classicbackpack",
    "id": "756"
  },
  {
     "Dimensions": "20cm (H) x 26cm (W) x 14cm (D)",
    "price": 175.00,
    "type": "Handbag",
    "categories": ["Handbag","Backpack"],
    "shape": "Cora",
    "name": "Cora Bag",
    "productInfo": " Comfortable handle, Detachable and adjustable vegan leather shoulder straps, 1 main compartment with zip closure, 1 inside zipped pocket, 1 inside open pocket, 1 external zipped pocket",
    "ranges": ["boutique"],
    "size": "large",
    "shapeId": "cora",
    "id": "474"
  }
 

]
export default shapeJson;
